import React, { useState, useEffect, useReducer, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, Modal } from "react-bootstrap";
import Collapse from "react-bootstrap/Collapse";
import { FounderMenu, BackerMenu, MenuListArray2 } from "./Menu";
import { FaCheckCircle } from "react-icons/fa";
import logo from "./../assets/images/logo.png";
import { signup } from "../apis/Signup";
import { login } from "../apis/Login";
import { resetPassword } from "../apis/ResetPassword"; // Import from apis/resetPassword.js
import { AppContext } from "../context/AppContext";
import { FaWallet } from "react-icons/fa";
import AuthModal from "../components/AuthModal";

const Header = () => {
  const { user, setUser, handleLogOut } = useContext(AppContext);
  // const MenuList = MenuListArray2;
  const MenuList =
    Object.keys(user).length !== 0 && user.user.role === "founder"
      ? FounderMenu
      : BackerMenu;
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [signupData, setSignupData] = useState({
    firstName: "",
    lastName: "",
    bio: "",
    role: "Role",
    email: "",
    password1: "",
    password2: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);

  // Modal visibility state
  const [showModal, setShowModal] = useState(false);

  // Form states
  // const [formErrors, setFormErrors] = useState(null);
  // const [isLoading, setIsLoading] = useState(false);
  // const [isSuccess, setIsSuccess] = useState(false);
  // Handlers for modal actions
  const handleLogin = async (loginData) => {
    setLoading(true);
    try {
      let response = await login(loginData);
      let result = response.data;
      setUser(result);
      localStorage.setItem("user", JSON.stringify(result));
      setLoginData({
        email: "",
        password: "",
      });
      setErrors({});
      setShowModal(false);
    } catch (error) {
      if (error.response?.status === 400 || error.response?.status === 401) {
        // console.log("error happened");
        // console.log(error);
        // console.log("error.response", error.response);
        // setErrors(error.response?.data);

        // Normalize the error response
        const responseData = error.response?.data;
        if (responseData.detail) {
          // Handle generic errors
          setErrors({ generic: [responseData.detail] });
        } else {
          // Handle field-specific errors
          setErrors(responseData);
        }

        localStorage.removeItem("user");
      } else {
        setErrors({
          email: ["Invalid credentials"],
          password: ["Wrong password"],
        });
        localStorage.removeItem("user");
      }
    }
    setLoading(false);
  };

  const handleSignup = async (signupData) => {
    if (loading) return;
    setLoading(true);

    try {
      let response = await signup(signupData);

      setSignupData({
        firstName: "",
        lastName: "",
        bio: "",
        role: "Role",
        email: "",
        password1: "",
        password2: "",
      });
      setSuccess(true);
      setErrors({});
    } catch (error) {
      if (error.response?.status === 400) {
        console.log("error happened");
        console.log(error);
        console.log("error.response", error.response);
        setErrors(error.response?.data);
      } else {
        setErrors({
          // signup: {
          error: ["Something went wrong."],
          // },
        });
      }
    }
    setLoading(false);
  };

  // setErrors({
  //   email: ["This email is already registered"],

  const handleReset = async (email) => {
    setLoading(true);
    try {
      // Simulate password reset API call
      await new Promise((resolve) => setTimeout(resolve, 1500));
      // Handle successful reset request
      setErrors({});
      setShowModal(false);
    } catch (error) {
      setErrors({
        reset: ["No account found with this email address"],
      });
    }
    setLoading(false);
  };

  //form submit
  // const nav = useNavigate();
  // const formSubmit = (e) => {
  //   e.prevantDefault();
  //   nav("/");
  // };

  // const loginForm = async (e) => {
  //   e.preventDefault();
  //   if (loading) return;
  //   setLoading(true);

  //   try {
  //     let response = await login(loginData);

  //     let result = response.data;
  //     setUser(result);
  //     let userData = JSON.stringify(result);
  //     localStorage.setItem("user", userData);
  //     setLoginData({
  //       email: "",
  //       password: "",
  //     });
  //     setErrors({});
  //     setloginModal(false);
  //   } catch (error) {
  //     if (error.response?.status === 400 || error.response?.status === 401) {
  //       setErrors(error.response?.data);
  //       localStorage.removeItem("user");
  //     } else {
  //       setUser({});
  //       localStorage.removeItem("user");
  //       console.log(error);
  //     }
  //   }

  //   setLoading(false);
  // };

  // const signupForm = async (e) => {
  //   e.preventDefault();
  //   if (loading) return;
  //   setLoading(true);

  //   try {
  //     let response = await signup(signupData);

  //     setSignupData({
  //       firstName: "",
  //       lastName: "",
  //       bio: "",
  //       role: "Role",
  //       email: "",
  //       password1: "",
  //       password2: "",
  //     });
  //     setSuccess(true);
  //     setErrors({});
  //   } catch (error) {
  //     if (error.response?.status === 400) {
  //       setErrors(error.response?.data);
  //     } else {
  //       console.log(error);
  //     }
  //   }

  //   setLoading(false);
  // };

  /* for sticky header */
  const [headerFix, setheaderFix] = React.useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setheaderFix(window.scrollY > 50);
    });
  }, []);

  //Modal
  // const [loginModal, setloginModal] = useState(false);
  // const [resetModal, setResetModal] = useState(false);
  // const [signupModal, setSignupModal] = useState(false);

  // //Modals end

  // //Auth Modal
  // const [showAuthModal, setShowAuthModal] = useState(false);
  // const [authError, setAuthError] = useState(null);
  //Auth Modal End

  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    var mainMenu = document.getElementById("OpenMenu");
    if (mainMenu) {
      if (sidebarOpen) {
        mainMenu.classList.add("show");
      } else {
        mainMenu.classList.remove("show");
      }
    }
  });

  // Menu dropdown list
  const reducer = (previousState, updatedState) => ({
    ...previousState,
    ...updatedState,
  });
  const initialState = {
    active: "",
    activeSubmenu: "",
  };
  const [state, setState] = useReducer(reducer, initialState);
  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  //let path = window.location.pathname;
  // Menu dropdown list End
  return (
    <>
      <header className="site-header mo-left header style-1">
        <div className="top-bar">
          <div className="container">
            <div className="dz-topbar-inner d-flex justify-content-between align-items-center">
              <div className="dz-topbar-left">
                <ul>
                  {/* <li>Welcome to Akcel, Crowdfunding & Charity Agency</li> */}
                  {Object.keys(user).length !== 0 ? (
                    <li>
                      <Link
                        to={"#"}
                        className="badge btn-login"
                        data-bs-toggle="modal"
                        data-bs-target="#modalLogin"
                        onClick={() => handleLogOut()}
                        style={{ backgroundColor: "#ff7468", color: "#fffff" }}
                      >
                        <i
                          className="flaticon-logout me-2"
                          style={{ color: "#ffffff" }}
                        ></i>
                        <span style={{ color: "#ffffff" }}>Logout</span>
                      </Link>
                      <div
                        style={{
                          color: "#1B8271",
                          display: "inline-block",
                          marginLeft: 15,
                          border: "2px solid #1B8271",
                          borderRadius: 5,
                          padding: "0px 5px",
                        }}
                      >
                        {" "}
                        <FaWallet />
                        <span style={{ marginLeft: 10, fontWeight: "600" }}>
                          {user.user.wallet_balance}
                        </span>
                      </div>
                    </li>
                  ) : (
                    <li>
                      <Link
                        to={"#"}
                        className="badge badge-primary btn-login"
                        data-bs-toggle="modal"
                        data-bs-target="#modalLogin"
                        onClick={() => setShowModal(true)}
                      >
                        <i className="flaticon-logout me-2"></i>Login / Sign Up
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
              <div className="dz-topbar-right">
                <ul>
                  <li>
                    {/* <i className="fas fa-map-marker-alt"></i> 394-091-3312 */}
                  </li>
                  <li>
                    <i className="fas fa-envelope"></i>support@kaf25.org
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`sticky-header main-bar-wraper navbar-expand-lg ${
            headerFix ? "is-fixed" : ""
          }`}
        >
          <div className="main-bar clearfix ">
            <div className="container clearfix">
              <div className="logo-header mostion logo-dark">
                <Link to={"/"}>
                  <img src={logo} alt="" />
                </Link>
              </div>
              <button
                className={`navbar-toggler navicon justify-content-end ${
                  sidebarOpen ? "open" : "collapsed"
                }`}
                type="button"
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
              {Object.keys(user).length !== 0 && (
                <div className="extra-nav">
                  <div className="extra-cell">
                    <Link
                      to={"#"}
                      className="btn btn-outline-secondary btnhover1"
                    >
                      <i className="fa-solid fa-user"></i>
                      <span className="m-l10">
                        {user.user.first_name} {user.user.last_name}
                      </span>
                    </Link>
                  </div>
                </div>
              )}
              <div
                className={`header-nav navbar-collapse collapse justify-content-end ${
                  sidebarOpen ? "show" : ""
                }`}
                id="navbarNavDropdown"
              >
                <div className="logo-header logo-dark">
                  <Link to={"/"}>
                    <img src={logo} alt="" />
                  </Link>
                </div>
                <ul className="nav navbar-nav navbar navbar-left">
                  {MenuList.map((data, index) => {
                    let menuClass = data.classChange;
                    if (menuClass !== "sub-menu-down") {
                      return (
                        <li className={menuClass} key={index}>
                          <Link to={data.to}>{data.title}</Link>
                        </li>
                      );
                    } else {
                      return (
                        <li
                          className={`${menuClass} ${
                            state.active === data.title ? "open" : ""
                          }`}
                          key={index}
                        >
                          {data.content && data.content.length > 0 ? (
                            <Link
                              to={"#"}
                              onClick={() => {
                                handleMenuActive(data.title);
                              }}
                            >
                              {data.title}
                            </Link>
                          ) : (
                            <Link to={data.to}>{data.title}</Link>
                          )}
                          <Collapse
                            in={state.active === data.title ? true : false}
                          >
                            <ul
                              className={`sub-menu ${
                                menuClass === "mm-collapse" ? "open" : ""
                              }`}
                            >
                              {data.content &&
                                data.content.map((data, index) => {
                                  return (
                                    <li
                                      key={index}
                                      className={`${
                                        state.activeSubmenu === data.title
                                          ? "open"
                                          : ""
                                      }`}
                                    >
                                      {data.content &&
                                      data.content.length > 0 ? (
                                        <>
                                          <Link
                                            to={data.to}
                                            onClick={() => {
                                              handleSubmenuActive(data.title);
                                            }}
                                          >
                                            {data.title}
                                            <i className="fa fa-angle-right" />
                                          </Link>
                                          <Collapse
                                            in={
                                              state.activeSubmenu === data.title
                                                ? true
                                                : false
                                            }
                                          >
                                            <ul
                                              className={`sub-menu ${
                                                menuClass === "mm-collapse"
                                                  ? "open"
                                                  : ""
                                              }`}
                                            >
                                              {data.content &&
                                                data.content.map(
                                                  (data, index) => {
                                                    return (
                                                      <>
                                                        <li key={index}>
                                                          <Link to={data.to}>
                                                            {data.title}
                                                          </Link>
                                                        </li>
                                                      </>
                                                    );
                                                  }
                                                )}
                                            </ul>
                                          </Collapse>
                                        </>
                                      ) : (
                                        <Link to={data.to}>{data.title}</Link>
                                      )}
                                    </li>
                                  );
                                })}
                            </ul>
                          </Collapse>
                        </li>
                      );
                    }
                  })}
                </ul>
                <div className="header-bottom">
                  {Object.keys(user).length !== 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="btn btn-light btn-login btn-sm"
                        data-bs-target="#modalLogin"
                        onClick={() => handleLogOut()}
                        style={{ backgroundColor: "#ff7468", color: "#fffff" }}
                      >
                        <i
                          className="flaticon-logout me-3"
                          style={{ color: "#ffffff" }}
                        ></i>
                        <span style={{ color: "#ffffff" }}>Logout</span>
                      </Link>

                      <div
                        style={{
                          color: "#1B8271",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "2px solid #1B8271",
                          borderRadius: 5,
                          padding: "3px",
                          marginTop: 15,
                        }}
                      >
                        {" "}
                        <FaWallet />
                        <span style={{ marginLeft: 10, fontWeight: "600" }}>
                          {user.user.wallet_balance}
                        </span>
                      </div>
                    </>
                  ) : (
                    <Link
                      to={"#"}
                      className="btn btn-light btn-login btn-sm"
                      data-bs-target="#modalLogin"
                      onClick={() => setShowModal(true)}
                    >
                      <i className="flaticon-logout me-3"></i>Login / Sign Up
                    </Link>
                  )}
                  <div className="dz-social-icon">
                    <ul>
                      <li>
                        <a
                          className="fab fa-facebook-f"
                          href="https://www.facebook.com/"
                          target="_blank"
                          rel="noreferrer"
                        ></a>
                      </li>{" "}
                      <li>
                        <a
                          className="fab fa-twitter"
                          href="https://twitter.com/"
                          target="_blank"
                          rel="noreferrer"
                        ></a>
                      </li>{" "}
                      <li>
                        <a
                          className="fab fa-linkedin-in"
                          href="https://www.linkedin.com/"
                          target="_blank"
                          rel="noreferrer"
                        ></a>
                      </li>{" "}
                      <li>
                        <a
                          className="fab fa-instagram"
                          href="https://www.instagram.com/"
                          target="_blank"
                          rel="noreferrer"
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* <button onClick={() => setShowAuthModal(true)}>Login/Signup</button> */}

      <AuthModal
        show={showModal}
        onHide={() => setShowModal(false)}
        mode="login" // optional default
        onLogin={(data) => handleLogin(data)}
        onSignup={(data) => handleSignup(data)}
        onReset={(email) => handleReset(email)}
        errors={errors}
        loading={loading}
        success={success}
        setSuccess={setSuccess} // Pass setSuccess prop
      />
    </>
  );
};

export default Header;
